import React from 'react';
import type { ChildrenProp } from '../common-types';

/**
 * Props for a {@link WorklineContainer} component.
 * @author aga
 */
export type WorklineContainerProps = ChildrenProp;

export function WorklineContainer({
  children
}: WorklineContainerProps): JSX.Element {
  return <div className="ehs-worklineContainer">{children}</div>;
}
